import { render, staticRenderFns } from "./ModalAddAnswer.vue?vue&type=template&id=ca6981ae&"
import script from "./ModalAddAnswer.vue?vue&type=script&lang=js&"
export * from "./ModalAddAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports